import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const LearnerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.dashboard',
        link: '/home',
    },
    {
        type: 'accordionLinkGroup',
        label: 'navigation.monitoring_group_learner',
        links: [
            {
                type: 'link',
                label: 'navigation.groups_management',
                link: '/groups/list/groups',
            },
            {
                type: 'link',
                label: 'navigation.workgroups_management',
                link: '/groups/list/workgroups',
            },
        ],
    },
    {
        type: 'link',
        label: 'navigation.assignment_learner',
        link: '/followed/tab/list',
    },
    {
        type: 'link',
        label: 'navigation.my_results',
        link: '/page/myresults',
    },
    {
        type: 'link',
        label: 'navigation.legal_notice',
        link: '/informations-legales',
    },
    {
        type: 'link',
        label: 'navigation.feedback',
        link: '/feedback',
    },
    {
        type: 'link',
        label: 'navigation.site_map',
        link: '/page/site-map',
    }
];
